export const WebhookLogsStatus = [
    { key: "Status", value: "" },
    { key: "Success", value: "success" },
    { key: "Failed", value: "failed" },
    { key: "Retried", value: "retried"}
];

export const WebhookEmailStatus = [
    { key: "Status", value: "" },
    { key: "Sent", value: "Sent" },
    { key: "Failed", value: "Failed" },
];

export const buildQueryParams = (params) => {
    return new URLSearchParams(
        Object.entries(params)
            .filter(([, value]) => value !== undefined && value !== "")
            .map(([key, value]) => [key, String(value)])
    ).toString();
};